import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-exclude-cancelled-jobs-lookup',
  templateUrl: './exclude-cancelled-jobs-lookup.component.html',
  styleUrls: ['./exclude-cancelled-jobs-lookup.component.css']
})
export class ExcludeCancelledJobsLookupComponent implements OnInit {
  @Input() from;
  @Input() set resetData(isClear) {
    if(isClear){
      this.clearFromParent();
    }
    
  }
  @Output() getCancelledJobsObj: EventEmitter<any> = new EventEmitter;
  excludeCancelledJobsAccount= false;
  
  constructor() { 
    this.excludeCancelledJobsAccount = (this.from == 'cummulative') ? true : false;
  }

  ngOnInit() {
    const preSelected = localStorage.getItem('filterObj');
    if (preSelected && JSON.parse(preSelected) &&
      JSON.parse(preSelected)['excludeCancelledJobs'] && JSON.parse(preSelected)['excludeCancelledJobs'].length) {
      this.excludeCancelledJobsAccount = JSON.parse(preSelected)['excludeCancelledJobs'];
    }
    if (preSelected && JSON.parse(preSelected) &&
      JSON.parse(preSelected)['cummulativeReport'] && JSON.parse(preSelected)['cummulativeReport'].length && this.from == 'cummulative') {
      this.excludeCancelledJobsAccount = JSON.parse(preSelected)['cummulativeReport'];
    }
  }

  onChange() {
    this.getCancelledJobsObj.emit(this.excludeCancelledJobsAccount);
  }

  clearFromParent() {
   this.excludeCancelledJobsAccount = false;
  }

}
